module.exports = __webpack_public_path__ + "img/youxiang.d71e6201.png";